// Servicios API para admin y otras utilidades
import { apiClient } from '../services/api';
import { API_BASE_URL } from '../config';

// Admin Stores API
export const adminStoresAPI = {
  getAll: (params = {}) => apiClient.get(`${API_BASE_URL}/api/admin/stores`, params),
  
  getById: (id) => apiClient.get(`${API_BASE_URL}/api/admin/stores/${id}`),
  
  create: (data) => apiClient.post(`${API_BASE_URL}/api/admin/stores`, data),
  
  update: (id, data) => apiClient.put(`${API_BASE_URL}/api/admin/stores/${id}`, data),
  
  delete: (id) => apiClient.delete(`${API_BASE_URL}/api/admin/stores/${id}`),
  
  toggle: (id, isParticipating) => apiClient.post(
    `${API_BASE_URL}/api/admin/stores/${id}/toggle`,
    { is_participating: isParticipating }
  ),
  
  toggleFeatured: (id, isFeatured) => apiClient.post(
    `${API_BASE_URL}/api/admin/stores/${id}/toggle-featured`,
    { is_featured: isFeatured }
  ),
};

// Admin Benefits API
export const adminBenefitsAPI = {
  getAll: () => apiClient.get(`${API_BASE_URL}/api/admin/benefits`),
  
  create: (data) => apiClient.post(`${API_BASE_URL}/api/admin/benefits`, data),
  
  update: (id, data) => apiClient.put(`${API_BASE_URL}/api/admin/benefits/${id}`, data),
  
  delete: (id) => apiClient.delete(`${API_BASE_URL}/api/admin/benefits/${id}`),
};

// Admin Statistics API
export const adminStatsAPI = {
  getOverview: () => apiClient.get(`${API_BASE_URL}/api/admin/statistics/overview`),
  
  getTopStores: () => apiClient.get(`${API_BASE_URL}/api/admin/statistics/top-stores`),
  
  getRecentActivity: () => apiClient.get(`${API_BASE_URL}/api/admin/statistics/recent-activity`),
};

// QR API (para QRSettings)
export const qrAPI = {
  getSettings: () => apiClient.get(`${API_BASE_URL}/api/qr/settings`),
};

export const adminQRAPI = {
  updateSettings: (duration) => apiClient.put(
    `${API_BASE_URL}/api/admin/qr/settings`,
    { duration }
  ),
};

// Admin Brands API
export const adminBrandsAPI = {
  getAll: (params = {}) => apiClient.get(`${API_BASE_URL}/api/admin/brands`, params),
  getById: (id) => apiClient.get(`${API_BASE_URL}/api/admin/brands/${id}`),
  create: (data) => apiClient.post(`${API_BASE_URL}/api/admin/brands`, data),
  update: (id, data) => apiClient.put(`${API_BASE_URL}/api/admin/brands/${id}`, data),
  delete: (id) => apiClient.delete(`${API_BASE_URL}/api/admin/brands/${id}`),
};

// Admin Promotions API
export const adminPromotionsAPI = {
  getAll: (params = {}) => apiClient.get(`${API_BASE_URL}/api/admin/promotions`, params),
  getById: (id) => apiClient.get(`${API_BASE_URL}/api/admin/promotions/${id}`),
  create: (data) => apiClient.post(`${API_BASE_URL}/api/admin/promotions`, data),
  update: (id, data) => apiClient.put(`${API_BASE_URL}/api/admin/promotions/${id}`, data),
  delete: (id) => apiClient.delete(`${API_BASE_URL}/api/admin/promotions/${id}`),
};

// Admin Ads API
export const adminAdsAPI = {
  getAll: (params = {}) => apiClient.get(`${API_BASE_URL}/api/admin/ads`, params),
  getById: (id) => apiClient.get(`${API_BASE_URL}/api/admin/ads/${id}`),
  create: (data) => apiClient.post(`${API_BASE_URL}/api/admin/ads`, data),
  update: (id, data) => apiClient.put(`${API_BASE_URL}/api/admin/ads/${id}`, data),
  delete: (id) => apiClient.delete(`${API_BASE_URL}/api/admin/ads/${id}`),
};

// Admin Subscribers API (read-only)
export const adminSubscribersAPI = {
  getAll: (params = {}) => apiClient.get(`${API_BASE_URL}/api/admin/subscribers`, params),
};

// Admin QR Redemptions API (read-only)
export const adminQrRedemptionsAPI = {
  getAll: (params = {}) => apiClient.get(`${API_BASE_URL}/api/admin/qr-redemptions`, params),
};

// Admin Outlet Map API
export const adminOutletMapAPI = {
  getMap: () => apiClient.get(`${API_BASE_URL}/api/admin/outlet-map`),
};

// Admin Featured Stores API (extended)
export const adminFeaturedStoresAPI = {
  getFeatured: () => apiClient.get(`${API_BASE_URL}/api/admin/featured-stores`),
  updateFeature: (id, data) => apiClient.put(`${API_BASE_URL}/api/admin/stores/${id}/feature`, data),
};

// Admin Promoters API
export const adminPromotersAPI = {
  getAll: (params = {}) => apiClient.get(`${API_BASE_URL}/api/admin/promoters`, params),
  getById: (id) => apiClient.get(`${API_BASE_URL}/api/admin/promoters/${id}`),
  create: (data) => apiClient.post(`${API_BASE_URL}/api/admin/promoters`, data),
  update: (id, data) => apiClient.put(`${API_BASE_URL}/api/admin/promoters/${id}`, data),
  delete: (id) => apiClient.delete(`${API_BASE_URL}/api/admin/promoters/${id}`),
  updateShowInDashboard: (id, showInDashboard) => apiClient.put(
    `${API_BASE_URL}/api/admin/promoters/${id}/show-in-dashboard`,
    { show_in_dashboard: showInDashboard }
  ),
};

// Admin Promoter Metrics API
export const adminPromoterMetricsAPI = {
  getOverview: (params = {}) => apiClient.get(`${API_BASE_URL}/api/admin/promoters/metrics/overview`, params),
  getPromoterMetrics: (id, params = {}) => apiClient.get(`${API_BASE_URL}/api/admin/promoters/${id}/metrics`, params),
  getTopPromoters: (params = {}) => apiClient.get(`${API_BASE_URL}/api/admin/promoters/metrics/top`, params),
  getRegisteredUsers: (id, params = {}) => apiClient.get(`${API_BASE_URL}/api/admin/promoters/${id}/registered-users`, params),
  getPaidUsers: (id, params = {}) => apiClient.get(`${API_BASE_URL}/api/admin/promoters/${id}/paid-users`, params),
  getDashboardPromoters: (params = {}) => apiClient.get(`${API_BASE_URL}/api/admin/promoters/metrics/dashboard`, params),
};

